import type { NodeApi } from "@hogartrabe/react-arborist-vrh";
import { ProjectCommissioningCalcQry } from "api/queries";
import type { Node } from "interfaces/schemas";
import { gqlFetchWithAuth } from "utils/fetchData/gqlFetchWithAuth";
import * as treeUtils from "utils/treeUtils";
import {
  getSetIsLoaderXCircle,
  getAddFetchingNodeId,
  getRemoveFetchingNodeId,
} from "stores/loadingStateStore";
import type { Project } from "../projectStore";
import { pasteNode } from "./pasteNode";

export const pasteWizardNode = async (
  node: NodeApi<Node> | null,
  parent: NodeApi<Node> | null,
  tree: Node[],
  project: Project,
  language: string,
  callback?: (node: Node) => void,
) => {
  if (!node) {
    throw new Error("No node to paste");
  }
  if (!parent) {
    throw new Error("No parent node to paste into");
  }
  if (!project?.id) {
    throw new Error("Project ID is missing. Cannot paste node.");
  }

  let price: number | null = null;

  const hasCommissioningCostNode = node.data?.nodes?.find((n) =>
    treeUtils.isWizardCommissioningCost(n),
  );

  const isActiveCommissioningCostNode =
    hasCommissioningCostNode?.active === true;

  if (hasCommissioningCostNode && isActiveCommissioningCostNode) {
    const setIsLoaderXCircle = getSetIsLoaderXCircle();
    const addFetchingNodeId = getAddFetchingNodeId();
    const removeFetchingNodeId = getRemoveFetchingNodeId();

    setIsLoaderXCircle(false);
    addFetchingNodeId(parent.id);
    try {
      const result = await gqlFetchWithAuth({
        query: ProjectCommissioningCalcQry,
        variables: {
          input: {
            projectId: project.id,
            projectNodeId: node.id,
            configurationOption: "onSite",
          },
        },
      });
      const rawPrice = result?.commissioningCalculation?.data?.price ?? null;
      price = rawPrice !== null ? Math.round(rawPrice * 100) : null;
    } catch (error) {
      console.error("Failed to fetch commissioning cost:", error);
    } finally {
      removeFetchingNodeId(parent.id);
    }
  }

  return pasteNode(node, parent, tree, project, language, price, callback);
};
